import { MutableRefObject, useEffect } from 'react'

export function useSubscribeToClickOutsideEvent(
    ref: MutableRefObject<HTMLElement | null>,
    onClickOutside: () => void,
    dependencies: unknown[] = []
) {
    function handleClickOutside(event: MouseEvent) {
        if (ref.current && !ref.current.contains(event.target as Node)) {
            onClickOutside()
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [ref, ...dependencies])
}
